// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3ukOY","right":"styles_right__2hrG1"};